module.exports = __webpack_public_path__ + "static/media/Exclusion 1.829be7b3.svg";